import React, { Component } from "react";
import { translate } from "../Services/translation";
import { forEach } from "lodash";

class FacetedSearchGroup extends Component {
  state = {
    selectedOption: null,
  };

  handleDropdownChange = (e) => {
    const { group, searchFacetChange } = this.props;
    const selectedValue = e.target.value;
    const filteredOptions = group.options.filter(
      (option) => option.id && option.label && option.quantity > 0
    );
    const selectedOption = filteredOptions[selectedValue];

    selectedOption.groupId = group.id;
    searchFacetChange(group, selectedOption);
  };

  render() {
    const { group } = this.props;
    const { selectedOption } = this.state;
    const filteredOptions = group.options.filter(
      (option) => option.id && option.label && option.quantity > 0
    );

    return (
      <div
        className="faceted-search__group__container"
        id={`faceted-search__group__container${group.id}`}
      >
        {group && filteredOptions && (
          <React.Fragment>
            <div className="faceted-search__wrapper">
              <select
                className="faceted-search__dropdown"
                onChange={this.handleDropdownChange}
                value={selectedOption ? selectedOption.id : ""}
              >
                <option value="">{group.label}</option>
                {filteredOptions.map((item, itemIndex) => (
                  <option key={`${item.label}-${itemIndex}`} value={itemIndex}>
                    {item.label} ({item.quantity})
                  </option>
                ))}
              </select>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

class FacetedSearchDlx extends Component {
  state = {
    selectedOptions: this.setInitSelected(),
  };

  setInitSelected() {
    const initSelected = [];
    if (this.props.facetFilters) {
      this.props.facetFilters.forEach((element) => {
        const choices = element.options.filter((x) =>
          element.selectedOptions.includes(x.id)
        );
        if (choices) {
          choices.forEach((o) => {
            initSelected.push({ ...o, groupId: element.id });
          });
        }
      });
    }
    return initSelected;
  }
  getGroupById(groupId) {
    return this.props.facetFilters.find((group) => group.id === groupId);
  }

  handleFacetChange = (group, selectedOption) => {
    const { selectedOptions } = this.state;

    const existingOption = selectedOptions.find(
      (option) => option.id === selectedOption.id
    );
    if (existingOption) {
      const updatedSelectedOptions = selectedOptions.filter(
        (option) => option.id !== selectedOption.id
      );
      updatedSelectedOptions.push({ ...selectedOption, groupId: group.id });
      this.setState({ selectedOptions: updatedSelectedOptions });
      this.handleRemoveSelectedOption(group.id, selectedOption);
    } else {
      this.setState((prevState) => ({
        selectedOptions: [
          ...prevState.selectedOptions,
          { ...selectedOption, groupId: group.id },
        ],
      }));
    }

    this.props.searchFacetChange(group, selectedOption);
  };

  handleRemoveSelectedOption = (groupId, selectedOption) => {
    const { selectedOptions } = this.state;
    const updatedSelectedOptions = selectedOptions.filter(
      (option) => option.id !== selectedOption.id
    );
    this.setState({ selectedOptions: updatedSelectedOptions });
    this.props.searchFacetChange(this.getGroupById(groupId), selectedOption);
  };

  render() {
    const { facetFilters, navigationTheme } = this.props;
    const { selectedOptions } = this.state;

    return (
      <div className="faceted-search-wrap">
        <div>
          <h3>{translate("facetedsearch.filter.placeholder")}</h3>
          <div className="faceted-search">
            {navigationTheme !== "category" &&
              facetFilters.map((group, groupIndex) => (
                <FacetedSearchGroup
                  key={`${group.label}-${groupIndex}`}
                  group={group}
                  selectedOption={selectedOptions[group.id]}
                  searchFacetChange={this.handleFacetChange}
                  removeSelectedOption={this.handleRemoveSelectedOption}
                />
              ))}
          </div>
        </div>
        <span className="faceted-search__applied-filters">
          <p>{translate("facetedsearch.filter.text.placeholder")} </p>
          {selectedOptions.map((selectedOption, index) => (
            <button
              key={`${selectedOption.groupId}-${index}`}
              className="filters-button"
              onClick={() =>
                this.handleRemoveSelectedOption(
                  selectedOption.groupId,
                  selectedOption
                )
              }
            >
              {selectedOption.label} <a className="close"></a>
            </button>
          ))}
        </span>
      </div>
    );
  }
}

export default FacetedSearchDlx;
